import autobind from 'autobind-decorator';
import { markRaw } from '#imports';
import { Inject, Injectable, forwardRef } from '@kaokei/use-vue-service';

@Injectable()
export class EmojiActionService {
  public visible = false;

  @autobind
  public toggleVisible() {
    this.visible = !this.visible;
  }
}
